/**
 * @fileoverview gRPC-Web generated client stub for mycargo.projects.erp.api.v1.services
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.20.3
// source: projects/erp/service/api/v1/services/shipments.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var projects_erp_service_api_v1_model_shipment_pb = require('./shipment_pb.js')
const proto = {};
proto.mycargo = {};
proto.mycargo.projects = {};
proto.mycargo.projects.erp = {};
proto.mycargo.projects.erp.api = {};
proto.mycargo.projects.erp.api.v1 = {};
proto.mycargo.projects.erp.api.v1.services = require('./shipments_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mycargo.projects.erp.api.v1.services.ShipmentsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mycargo.projects.erp.api.v1.services.ShipmentsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.ListShipmentsRequest,
 *   !proto.mycargo.projects.erp.api.v1.services.ListShipmentsResponse>}
 */
const methodDescriptor_Shipments_ListShipments = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.Shipments/ListShipments',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.ListShipmentsRequest,
  proto.mycargo.projects.erp.api.v1.services.ListShipmentsResponse,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.ListShipmentsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.mycargo.projects.erp.api.v1.services.ListShipmentsResponse.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.ListShipmentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.services.ListShipmentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.services.ListShipmentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.ShipmentsClient.prototype.listShipments =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.Shipments/ListShipments',
      request,
      metadata || {},
      methodDescriptor_Shipments_ListShipments,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.ListShipmentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.services.ListShipmentsResponse>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.ShipmentsPromiseClient.prototype.listShipments =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.Shipments/ListShipments',
      request,
      metadata || {},
      methodDescriptor_Shipments_ListShipments);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mycargo.projects.erp.api.v1.services.GetShipmentRequest,
 *   !proto.mycargo.projects.erp.api.v1.model.Shipment>}
 */
const methodDescriptor_Shipments_GetShipment = new grpc.web.MethodDescriptor(
  '/mycargo.projects.erp.api.v1.services.Shipments/GetShipment',
  grpc.web.MethodType.UNARY,
  proto.mycargo.projects.erp.api.v1.services.GetShipmentRequest,
  projects_erp_service_api_v1_model_shipment_pb.Shipment,
  /**
   * @param {!proto.mycargo.projects.erp.api.v1.services.GetShipmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_shipment_pb.Shipment.deserializeBinary
);


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.GetShipmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mycargo.projects.erp.api.v1.model.Shipment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mycargo.projects.erp.api.v1.model.Shipment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mycargo.projects.erp.api.v1.services.ShipmentsClient.prototype.getShipment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.Shipments/GetShipment',
      request,
      metadata || {},
      methodDescriptor_Shipments_GetShipment,
      callback);
};


/**
 * @param {!proto.mycargo.projects.erp.api.v1.services.GetShipmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mycargo.projects.erp.api.v1.model.Shipment>}
 *     Promise that resolves to the response
 */
proto.mycargo.projects.erp.api.v1.services.ShipmentsPromiseClient.prototype.getShipment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mycargo.projects.erp.api.v1.services.Shipments/GetShipment',
      request,
      metadata || {},
      methodDescriptor_Shipments_GetShipment);
};


module.exports = proto.mycargo.projects.erp.api.v1.services;

